export default "__VITE_ASSET__Cq2U2XsF__"